// Importaciones previas...
import { useEffect, useState } from 'react';
import { _AbstractAccount, _AccountINFORPO, _Affiliate, _single, _ThirdBankingAccount } from '../../../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import { CardTaps } from '../../../../../../modules/theme/Component/CardTaps';
import { PersonalInfoTab } from './Components/PersonalInfoTab';
import { PersonalReferenceTab } from './Components/PersonalReferenceTab';
import { PersonalDocumentsTab } from './Components/PersonalDocumentTab';
import { PrintJson } from '../../../../../../modules/theme/Component/PrintJson';
import { ThirdBankingAccount } from '../../../../../../modules/Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount';
import { BasicButton } from '../../../../../../modules/theme/Component/BasicButton';

interface Props {
    onClickSave?: Function;
    showOnlyTabId?: number;
    idAffiliate?: number;
    type?: number[];
    _PayrollType?: number;
    _LoanLine?: number;
}

export const PersonalAccountData = ({ onClickSave, showOnlyTabId, idAffiliate, type = [100, 101], _LoanLine, _PayrollType }: Props) => {
    const { instance, bean, setBean } = useDataBean(_Affiliate);
    const banking = useDataBean(_ThirdBankingAccount);
    const accF = useDataBean(_AbstractAccount);
    const [props, setProps] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [indexTap, setIndexTap] = useState(0);

    useEffect(() => {
        if (idAffiliate) {
            getAffiliate(idAffiliate);
            getLista();
        }
    }, [idAffiliate]);


    useEffect(() => {
        if (bean?.JSONProps) {
            setProps(JSON.parse(bean.JSONProps));
        }
    }, [bean.JSONProps]);

    const getAffiliate = (idAccount: number) => {
        const Props = { IDAccount: idAccount };
        instance.getAffiliateCatalogPorPropiedades(Props, null).then(resp => {
            if (resp.length > 0) {
                getAccInforpo(resp[0].DataBeanProperties.IDAccount, resp[0].DataBeanProperties);
                _single.startSessionAffiliate(resp[0].DataBeanProperties)
            } else {
                instance.updateAffiliate({
                    IDAccount: _single.getAccount().IDAccount,
                    State: 1,
                    CorreoInstitucional: _single.getAccount().eMail,
                    Nit: _single.getAccount().Nit,
                    NumeroCelular: _single.getAccount().Tel,
                    PrimerNombre: _single.getAccount().Name1,
                    SegundoNombre: _single.getAccount().Name2,
                    PrimerApellido: _single.getAccount().Surname1,
                    SegundoApellido: _single.getAccount().Surname2,
                }).catch(err => { toast.error("No se pudo consultar la informacion del usuario") })
                window.location.reload();
            }
        }).catch(err => {
            console.error(err);
            toast.error("Error al cargar la información del usuario");
        });
    };



    const getLista = () => {
        banking.instance.getThirdBankingAccountCatalogByIDAccount(idAffiliate, null).then(
            (resp: any) => {
                if (resp) {
                    let List = resp;
                    List.forEach((e: any) => {
                        e.DataBeanProperties.BankingNameCode = (e.DataBeanProperties.BankingCode ?? '') +
                            (e.DataBeanProperties.BankingName ?? '')
                    })
                    banking.setLista(List);
                    if (List.length > 0) {
                        setBean({ ...bean, IDThirdBankingAccount: null })
                    }
                }
            }
        )

    }

    const getAccInforpo = (nit, objeto) => {
        accF.instance.getAccountbyID(nit).then(
            (resp) => {
                setBean({ ...objeto, Nit: objeto.Nit ?? resp.Nit, SegundoApellido: objeto.SegundoApellido ?? resp.Surname2, PrimerApellido: objeto.PrimerApellido ?? resp.Surname1, PrimerNombre: objeto.PrimerNombre ?? resp.Name1, SegundoNombre: objeto.SegundoNombre ?? resp.Name2, CorreoPersonal: objeto.CorreoPersonal ?? resp.eMail })
            }
        ).catch(
            err => {
                toast.error("no se pudo migrar la información")
            }
        )
    }

    const updateAffiliate = () => {
        const updatedBean = { ...bean, JSONProps: JSON.stringify(props), SyncDate: _single.getCurrenDate() };
        instance.updateAffiliate(updatedBean).then(resp => {
            toast.success("Se actualizó la información del usuario");
            onClickSave?.(updatedBean);
            getAffiliate(idAffiliate)
        })
            .catch(err => console.error(err));
    };

    const taps = [
        { id: 0, name: 'Información Básica', disable: false },
        { id: 1, name: 'Referencias', disable: false },
        { id: 2, name: 'Documentos', disable: false },
        { id: 3, name: 'Cuentas Bancarias', disable: false },
    ];

    const getTimeDiffText = (fechaInicio: string | Date) => {
        if (!fechaInicio) return "";
        const start = new Date(fechaInicio);
        const now = new Date();
        const diffInMs = now.getTime() - start.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        const years = Math.floor(diffInDays / 365);
        const months = Math.floor((diffInDays % 365) / 30);
        const days = (diffInDays % 365) % 30;
        return `${years} año(s), ${months} mes(es), ${days} día(s)`;
    };

    if (showOnlyTabId !== undefined) {
        if (showOnlyTabId === 0) {
            return (
                <div className="row p-4">
                    <PersonalInfoTab
                        bean={bean}
                        setBean={setBean}
                        props={props}
                        setProps={setProps}
                        missingFields={missingFields}
                        setMissingFields={setMissingFields}
                        updateAffiliate={updateAffiliate}
                        getTimeDiffText={getTimeDiffText}
                    />
                </div>
            );
        } else if (showOnlyTabId === 1) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <PersonalReferenceTab
                            props={props}
                            setProps={setProps}
                            missingFields={missingFields}
                            setMissingFields={setMissingFields}
                            updateAffiliate={updateAffiliate}
                        />
                    </div>
                </div>
            )
        } else if (showOnlyTabId === 2) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <PersonalDocumentsTab _payrollType={_PayrollType} _loanLine={_LoanLine} idAccount={idAffiliate} updateAffiliate={updateAffiliate} type={type} />
                    </div>
                </div>
            )
        } else if (showOnlyTabId === 3) {
            return (
                <div className="row">
                    {banking.lista.length > 0 &&
                        <>
                            <div className="col-md-10">
                                <label>Cuenta Desemboloso por Defecto</label>
                                <select className='form-select' value={bean.IDBancoDesembolso} onChange={(e) => { setBean({ ...bean, IDBancoDesembolso: parseInt(e.target.value) }) }} >
                                    <option value="">...</option>
                                    {banking.lista.map((bancos) => {
                                        const banco = bancos.DataBeanProperties
                                        return (
                                            <option key={banco.IDThirdBankingAccount} value={banco.IDThirdBankingAccount}>{banco.BankingName} - {banco.AccountNumber}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="col-md-2 mt-4">
                                <BasicButton
                                    eventClick={updateAffiliate}
                                    icon="ri-save-line"
                                    children="Guardar"
                                />
                            </div>
                        </>
                    }
                    <div className="col-md-12">
                        <ThirdBankingAccount onChange={() => { getLista() }} canModify isModal idAccount={idAffiliate} />
                    </div>
                </div>
            )
        }
        return null;
    }

    return (
        <div className="row p-4">
            <div className="col-md-12">
                <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                    {indexTap === 0 && (
                        <PersonalInfoTab
                            bean={bean}
                            setBean={setBean}
                            props={props}
                            setProps={setProps}
                            missingFields={missingFields}
                            setMissingFields={setMissingFields}
                            updateAffiliate={updateAffiliate}
                            getTimeDiffText={getTimeDiffText}
                        />
                    )}
                    {indexTap === 1 && (
                        <PersonalReferenceTab
                            props={props}
                            setProps={setProps}
                            missingFields={missingFields}
                            setMissingFields={setMissingFields}
                            updateAffiliate={updateAffiliate}
                        />
                    )}
                    {indexTap === 2 && (
                        <PersonalDocumentsTab _payrollType={_PayrollType} _loanLine={_LoanLine} idAccount={idAffiliate} updateAffiliate={updateAffiliate} type={type} />
                    )}
                    {indexTap === 3 && (
                        <div className="row">
                            {banking.lista.length > 0 &&
                                <>
                                    <div className="col-md-10">
                                        <label>Cuenta Desemboloso por Defecto</label>
                                        <select className='form-select' value={bean.IDBancoDesembolso} onChange={(e) => { setBean({ ...bean, IDBancoDesembolso: parseInt(e.target.value) }) }} >
                                            <option value="">...</option>
                                            {banking.lista.map((bancos) => {
                                                const banco = bancos.DataBeanProperties
                                                return (
                                                    <option key={banco.IDThirdBankingAccount} value={banco.IDThirdBankingAccount}>{banco.BankingName} - {banco.AccountNumber}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-2 mt-4">
                                        <BasicButton
                                            eventClick={updateAffiliate}
                                            icon="ri-save-line"
                                            children="Guardar"
                                        />
                                    </div>
                                </>
                            }
                            <div className="col-md-12">
                                <ThirdBankingAccount onChange={() => { getLista() }} canModify isModal idAccount={idAffiliate} />
                            </div>
                        </div>
                    )}
                </CardTaps>
            </div>
        </div>
    );
};
